import { useState } from 'react';

export const useToggle = (initialValue = false): [boolean, () => void] => {
  const [toggle, setToggle] = useState<boolean>(initialValue);

  const toggleValue = () => setToggle(t => !t);

  return [toggle, toggleValue];
};
